import React, { Component } from 'react'
import { Image, Segment } from 'semantic-ui-react'
import PropTypes from 'prop-types'

class PrintLayout extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render () {
    return (
      <Segment basic id='print-body'>
        <Image src='/img/mci/mci_logo_new.png' size='small' />
        {this.props.children}
      </Segment>
    )
  }
}

export default PrintLayout
